import React from 'react'

import PropTypes from 'prop-types'

import './faq1.css'

const FAQ1 = (props) => {
  return (
    <div
      className={`faq1faq7 thq-section-padding ${props.rootClassName} `}
    ></div>
  )
}

FAQ1.defaultProps = {
  rootClassName: '',
}

FAQ1.propTypes = {
  rootClassName: PropTypes.string,
}

export default FAQ1
